@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  colorexploratoryrunfail: $color-highlight-red;
  colordirectrunfail: $color-primary-red;
}
/* stylelint-enable */
.chartContainerStyle {
  position: 'relative';
  min-height: 8em;
}
